import moment from 'moment'

export const formatDate = date => moment(date).format('DD/MM/YYYY')
export const formatPayloadDate = date => moment(date).format('YYYY-MM-DD')
